import React from 'react';
import PropTypes from 'prop-types';
import Content from '../UI/Content';
import ActionItems from '../UI/StrategiesRecos/ActionItems';
import Strategies from '../UI/StrategiesRecos/Strategies';
import Recos from '../UI/StrategiesRecos/Recos';
import '../UI/StrategiesRecos/index.css';

const StrategiesRecos = ({
  strategies, recos, actionItems, isAgent,
}) => (
  <Content>
    <div className="action-items-etc">
      <div className="strategies-etc">
        <Strategies strategies={strategies} isAgent={isAgent} />
        <Recos recos={recos} isAgent={isAgent} />
      </div>
      <ActionItems
        actionItems={
          actionItems
            ? actionItems.filter(
              actionItem => actionItem.attributes.showOnBlueprint,
            )
            : []
        }
      />
    </div>
  </Content>
);

StrategiesRecos.propTypes = {
  strategies: PropTypes.array.isRequired,
  recos: PropTypes.array.isRequired,
  actionItems: PropTypes.array.isRequired,
  isAgent: PropTypes.bool.isRequired,
};

export default StrategiesRecos;
